export const protocolStateIds = {
    undefined: 0,
    // Создан
    created: 1,
    // В процессе
    signed: 2,
    declined: 3
};

export function isSignedProtocol(item) {
    const p = item?.protocol ?? item;
    return Number(p?.stateId) === protocolStateIds.signed;
}

/** Список элементов протокола или связей { protocol: {...} } (предписание/постановление) либо самих протоколов (акт). */
export function hasSignedProtocol(protocols) {
    if (!protocols?.length) {
        return false;
    }
    return protocols.some(isSignedProtocol);
}

export function filterSignedProtocols(protocols) {
    return (protocols || []).filter(isSignedProtocol);
}